export const Localstorage = {
  AccountStore: "account.store",
  AuthStore: "auth.store",
  HomeTabStore: "home-tab.store",
  NotificationStore: "notification.store",
  PreferencesStore: "preferences.store",
  ProStore: "pro.store",
  ReloadTabs: "reload.tabs",
  SearchStore: "search.store",
  Theme: "theme"
};
